import { t, translateMessage } from "../i18n";
import { X } from "lucide-react";
import { useEffect, useRef } from "react";

type Props = {
  message: string;
  onClose: () => void;
};

export function Toast({ message, onClose }: Props) {
  const closeRef = useRef(onClose);

  useEffect(() => {
    closeRef.current = onClose;
  }, [onClose]);

  useEffect(() => {
    if (!message) {
      return;
    }
    // The App re-renders during live sync. Keeping onClose out of this timer's dependencies
    // prevents those refreshes from restarting the countdown indefinitely.
    const isError = /απέτυχ|σφάλμα|εκτός σύνδεσης|παραμένει άγνωστο|δεν (έγινε|αποθηκεύ|ενημερώ|άλλαξ|έκλει|ακυρώ|διαγράφη|επιτράπ)|failed|error|offline|unknown|could not|cannot|denied|not (saved|updated|changed|closed|cancelled|deleted|allowed)/i.test(message);
    const timer = window.setTimeout(() => closeRef.current(), isError ? 8000 : 4000);
    return () => window.clearTimeout(timer);
  }, [message]);

  if (!message) {
    return null;
  }
  return (
    <div className="toast" role="status">
      <span>{translateMessage(message)}</span>
      <button type="button" className="icon-button" onClick={onClose} aria-label={t("Κλείσιμο")}>
        <X />
      </button>
    </div>
  );
}
